customElements.define(
  "collapsible-container",
  class Openable extends HTMLElement {
    constructor() {
      super();

      this.toggleContainer = this.querySelector(
        ".collapsible-toggle-container"
      );

      if (!this.toggleContainer) return;

      this.toggleBtn = this.toggleContainer.querySelector(
        ".collapsible-toggle-btn"
      );

      this.contentContainer = this.querySelector(
        ".collapsible-content-container"
      );

      // תיקון אוטומטי: מבטיח שכל תוכן ה-content-container עטוף בשתי
      // שכבות - שכבה חוצה בלי padding (מתכווצת ל-0 אמיתי) ושכבה
      // פנימית עם ה-padding. אם ה-padding יושב על השכבה שמתכווצת,
      // הוא נשאר גלוי גם כשהגובה 0 (זו הייתה סיבת ה"דליפה").
      if (this.contentContainer) {
        let inner = this.contentContainer.querySelector(
          ':scope > .collapsible-content-inner'
        );

        if (!inner) {
          inner = document.createElement('div');
          inner.className = 'collapsible-content-inner';

          const padded = document.createElement('div');
          padded.className = 'collapsible-content-padding';

          while (this.contentContainer.firstChild) {
            padded.appendChild(this.contentContainer.firstChild);
          }

          inner.appendChild(padded);
          this.contentContainer.appendChild(inner);
        } else if (!inner.querySelector(':scope > .collapsible-content-padding')) {
          // יש כבר inner (מה-Liquid), אבל בלי שכבת ה-padding הנוספת
          const padded = document.createElement('div');
          padded.className = 'collapsible-content-padding';

          while (inner.firstChild) {
            padded.appendChild(inner.firstChild);
          }

          inner.appendChild(padded);
        }
      }

      this.toggleContainer.addEventListener("click", () =>
        this.toggleContainerVisibility()
      );
    }

    toggleContainerVisibility() {
      const isCurrentlyOpen = this.getAttribute("data-open") === "true";

      // סוגר את כל האחרים הפתוחים (רק אחד פתוח בכל רגע)
      document
        .querySelectorAll('collapsible-container[data-open="true"]')
        .forEach((otherCollapsible) => {
          if (otherCollapsible !== this) {
            otherCollapsible.setAttribute("data-open", "false");
            const otherBtn = otherCollapsible.querySelector(
              ".collapsible-toggle-btn"
            );
            if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
          }
        });

      const newState = !isCurrentlyOpen;
      this.setAttribute("data-open", newState ? "true" : "false");
      if (this.toggleBtn) {
        this.toggleBtn.setAttribute("aria-expanded", newState ? "true" : "false");
      }
    }
  }
);
